import client from './client';
import qs from 'qs';

/**
 * 아이디 확인
 * @param {string} userId
 */
export const member = (userId) => client.get(`/api/manage/member/${userId}`);

/**
 * 사용자 등록
 * @param {json} params
 */
export const register = (params) =>
  client.post('/api/register', qs.stringify(params));

/**
 * 사용자 리스트
 * @param {json} params
 */
export const members = (param) => client.get(`/api/manage/members`, param);

/**
 * 모비온 사용자를 검색한다.
 */
export const memberSearch = (param) =>
  client.get('/api/user/search', { params: param });

/**
 * 사번을 이용해 유저 정보를 불러온다
 */
export const getUserInfoForNo = (param) =>
  client.get('/api/manage/erp', { params: param });

/**
 * 사용자관리 페이지 검색폼 리스트
 */
export const usersSearch = () => client.get(`/api/layout/member/search`);

export const getUserInfo = () => client.get('/api/user');

/**
 * 광고주 id, 관리자 id에 따른 대행사 리스트
 */
export const chargeAuthCheck = ({ userId }) =>
  client.get(
    `/api/manage/members/modal/reload/${userId}`,
    qs.stringify(
      {
        userId,
      },
      {
        skipNulls: true,
        filter: function filterFunc(prefix, value) {
          for (let item in value) {
            if (value.hasOwnProperty(item)) {
              const cur = value[item];
              if (cur === '') {
                value[item] = null;
              }
            }
          }
          return value;
        },
      }
    )
  );

//보너스 충전 선불예약, 후불예약 정보
export const reserveCheck = ({ userId, date, time }) =>
  client.get(
    `/api/manage/members/modal/reserve/${userId}?rsvDate=${date}&rsvTime=${time}`,
    qs.stringify(
      {
        userId,
        date,
        time,
      },
      {
        skipNulls: true,
        filter: function filterFunc(prefix, value) {
          for (let item in value) {
            if (value.hasOwnProperty(item)) {
              const cur = value[item];
              if (cur === '') {
                value[item] = null;
              }
            }
          }
          return value;
        },
      }
    )
  );

// 모비온 사용자 입금
export const deposit = ({
  userId,
  setleUserId,
  modiDate,
  payPoint,
  name,
  agency,
  balancePoint,
  agencyFee,
  placeboFee,
  dealType,
  reloadPoint,
  rsvTime,
  weekType,
  pointType,
}) =>
  client.post(
    `/api/manage/members/modal/${pointType}/${userId}`,
    qs.stringify(
      {
        userId,
        setleUserId,
        modiDate,
        payPoint,
        name,
        agency,
        balancePoint,
        agencyFee,
        placeboFee,
        dealType,
        reloadPoint,
        rsvTime,
        weekType,
      },
      {
        skipNulls: true,
        filter: function filterFunc(prefix, value) {
          for (let item in value) {
            if (value.hasOwnProperty(item)) {
              const cur = value[item];
              if (cur === '') {
                value[item] = null;
              }
            }
          }
          return value;
        },
      }
    )
  );

// 모비온 사용자 보너스충전
export const chargeBonus = ({
  userId,
  restRsnCode,
  dtlRestRsnCode,
  rsvDate,
  rsvTime,
  weekType,
  memo,
  payPoint,
}) =>
  client.post(
    `/api/manage/members/modal/reload/${userId}`,
    qs.stringify(
      {
        userId,
        restRsnCode,
        dtlRestRsnCode,
        rsvDate,
        rsvTime,
        weekType,
        memo,
        payPoint,
      },
      {
        skipNulls: true,
        filter: function filterFunc(prefix, value) {
          for (let item in value) {
            if (value.hasOwnProperty(item)) {
              const cur = value[item];
              if (cur === '') {
                value[item] = null;
              }
            }
          }
          return value;
        },
      }
    )
  );
// 모비온 사용자 보너스충전 선불,후불 등록리스트 수정
export const chargeBonusEdit = ({
  userId,
  restRsnCode,
  rsvDate,
  rsvTime,
  weekType,
  payPoint,
}) =>
  client.put(
    `/api/manage/members/modal/reload/${userId}`,
    qs.stringify(
      {
        userId,
        restRsnCode,
        rsvDate,
        rsvTime,
        weekType,
        payPoint,
      },
      {
        skipNulls: true,
        filter: function filterFunc(prefix, value) {
          for (let item in value) {
            if (value.hasOwnProperty(item)) {
              const cur = value[item];
              if (cur === '') {
                value[item] = null;
              }
            }
          }
          return value;
        },
      }
    )
  );

// 모비온 사용자 보너스충전 선불,후불 등록리스트 삭제
export const chargeBonusDelete = ({
  userId,
  restRsnCode,
  rsvDate,
  rsvTime,
  weekType,
  payPoint,
}) =>
  client.delete(`/api/manage/members/modal/reserve/${userId}`, {
    data: {
      userId,
      restRsnCode,
      rsvDate,
      rsvTime,
      weekType,
      payPoint,
    },
  });

// 회원 상점 상태 변경
export const chopChange = ({ userId, pltfomTpCode, state }) =>
  client.post(`/api/manage/members/${userId}/shopChange`, {
    pltfomTpCode: pltfomTpCode,
    state: state,
  });
